import {ERequestType} from 'shared/types/requests';
import {performRequest} from 'shared/utils';

import {IGetDataArgs} from '../model/types';
import {IGetDataOrgInfoResponse, IPostDataOrgInfoArgs, IDeleteDataOrgInfoArgs, IPutDataOrgInfoArgs} from './types';

const ORG_INFO_ROUTE = 'integration.module/ais3.company.group.info/ais3.company.group.info.org';

const getData = (args?: IGetDataArgs) =>
    performRequest<IGetDataOrgInfoResponse>({
        url: ORG_INFO_ROUTE,
        method: ERequestType.GET,
        params: {paginationPageSize: args?.paginationPageSize, paginationCurrent: args?.paginationCurrent},
    });

const postData = (args: IPostDataOrgInfoArgs) =>
    performRequest<string>({url: ORG_INFO_ROUTE, data: args, method: ERequestType.POST});

const putData = (args: IPutDataOrgInfoArgs) =>
    performRequest<string>({url: `${ORG_INFO_ROUTE}/${args.id}`, data: args, method: ERequestType.PUT});

const deleteData = (args: IDeleteDataOrgInfoArgs) =>
    performRequest<string>({
        url: `${ORG_INFO_ROUTE}/rpc/delete-list`,
        data: {ids: args.rowsIds},
        method: ERequestType.DELETE,
    });

export const orgInfoApi = {getData, postData, putData, deleteData};
